import React from 'react';
import '../App.css';
import { logOut } from '../api/api';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { OriginServerName } from '../api/api';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

export class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            profilePage: false,
            drawerOpen: false,
        };
    }

    handlelogout = async () => {
        await logOut();
    };

    tabChange = () => {
        this.setState({ profilePage: false, drawerOpen: false });
    };

    toggleDrawer = (open) => {
        this.setState({ drawerOpen: open });
    };

    render() {
        const { token, is_pwd_updated, pwd_expires_in, is_pwd_expired } = this.props.user;
        const url = 'https://firstmatch.com/';
        const screenName = window.location.pathname.split('/').pop();

        const navLinks = token ? (
            <List style={{ width: 250 }}>
                <ListItem
                    button
                    component={Link}
                    to="/admin/changepassword"
                    onClick={() => this.setState({ profilePage: true, drawerOpen: false })}
                >
                    <ListItemText primary="Profile" />
                </ListItem>
                {!is_pwd_expired && (
                    <ListItem
                        button
                        component={Link}
                        to="/admin/org-configure/"
                        onClick={this.tabChange}
                    >
                        <ListItemText primary="Configure FirstMatch®" />
                    </ListItem>
                )}
                {is_pwd_updated !== false && !is_pwd_expired && (
                    <>
                        <ListItem button component={Link} to="/admin/configure" onClick={this.tabChange}>
                            <ListItemText primary="Configure" />
                        </ListItem>
                        <ListItem button component={Link} to="/admin/eiflist" onClick={this.tabChange}>
                            <ListItemText primary="Interest Forms" />
                        </ListItem>
                        <ListItem button component={Link} to="/admin/raflist" onClick={this.tabChange}>
                            <ListItemText primary="Assessment Forms" />
                        </ListItem>
                    </>
                )}
                <Divider />
                <ListItem button onClick={this.handlelogout}>
                    <ListItemText primary="Logout" />
                </ListItem>
            </List>
        ) : null;

        return (
            <div id="app" className="container-fluid">
                {token && pwd_expires_in <= 10 ? (
                    this.state.show ? (
                        ''
                    ) : (
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                            Your password {is_pwd_expired ? 'has expired' : `will expire in ${pwd_expires_in} days`}.
                            {this.state.profilePage || screenName === 'changepassword' ? (
                                ''
                            ) : (
                                <>
                                    &nbsp;Please{' '}
                                    <Link className="text-danger fw-semibold" to={`${token && '/admin/changepassword'}`}>
                                        <strong>click here</strong>
                                    </Link>{' '}
                                    to change your password!
                                </>
                            )}
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => this.setState({ show: true })}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    )
                ) : (
                    ''
                )}

                <nav className="navbar navbar-expand-lg navbar-light">
                    <Link className="navbar-brand" onClick={this.tabChange} to={`${token ? (is_pwd_expired ? '/admin/changepassword' : '/admin/configure') : url}`}>
                        <img className="navbar-brand" alt="FirstMatch Logo" src="/img/logo_stroke.png" width="40%" height="40%" />
                    </Link>

                    {/* Hamburger button — visible only on small screens */}
                    <IconButton
                        className="d-lg-none ml-auto"
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        onClick={() => this.toggleDrawer(true)}
                    >
                        <MenuIcon />
                    </IconButton>

                    {/* Desktop nav — hidden on small screens */}
                    <div id="navbarNav" className="collapse navbar-collapse d-none d-lg-flex">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item"><h1>{OriginServerName ? OriginServerName : ''}</h1></li>
                        </ul>
                        {token ? (
                            <ul className="navbar-nav mr-right">
                                <li className={`nav-item ${is_pwd_expired ? 'd-none' : 'd-inline'}`}>
                                    <Link className="btn btn-primary" onClick={this.tabChange} to="/admin/org-configure/">
                                        Configure FirstMatch&reg;
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/admin/changepassword" onClick={() => this.setState({ profilePage: true })}>
                                        Profile
                                    </Link>
                                </li>
                                {is_pwd_updated === false ? (
                                    ''
                                ) : (
                                    <>
                                        <li className={`nav-item ${is_pwd_expired ? 'd-none' : 'd-inline'}`}>
                                            <Link className="nav-link" onClick={this.tabChange} to="/admin/configure">
                                                Configure
                                            </Link>
                                        </li>
                                        <li className={`nav-item ${is_pwd_expired ? 'd-none' : 'd-inline'}`}>
                                            <Link className="nav-link" onClick={this.tabChange} to="/admin/eiflist">
                                                Interest Forms
                                            </Link>
                                        </li>
                                        <li className={`nav-item ${is_pwd_expired ? 'd-none' : 'd-inline'}`}>
                                            <Link className="nav-link" onClick={this.tabChange} to="/admin/raflist">
                                                Assessment Forms
                                            </Link>
                                        </li>
                                    </>
                                )}
                                <li className="nav-item">
                                    <button className="btn btn-link" onClick={this.handlelogout}>
                                        Logout
                                    </button>
                                </li>
                            </ul>
                        ) : (
                            ''
                        )}
                    </div>
                </nav>

                {/* Mobile drawer */}
                <Drawer anchor="right" open={this.state.drawerOpen} onClose={() => this.toggleDrawer(false)}>
                    {navLinks}
                </Drawer>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.loginData.user
});
export default connect(mapStateToProps)(Header);
